import { render, staticRenderFns } from "./SaleTypeSelect.vue?vue&type=template&id=401abd28"
import script from "./SaleTypeSelect.vue?vue&type=script&lang=ts"
export * from "./SaleTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports